var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({attrs:{"type":"text","autocomplete":"off","data-cy":"clock-picker"},domProps:{"value":_vm.formattedTime}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }